<template>
  <div>
    <span v-if="device.bateryStatus > 0 && device.bateryStatus < 255">
      <div
        v-if="
          Math.round((device.bateryStatus / 254) * 100, 2) < 81 &&
            Math.round((device.bateryStatus / 254) * 100, 2) > 60
        "
        class="d-flex align-items-center"
      >
        <img src="@/assets/icons/battery/ico-battery-80.svg" />
        <span class="detail-page__boxes__item__textDashed">
          {{ Math.round((device.bateryStatus / 254) * 100, 2) }}%
        </span>
      </div>
      <div
        v-if="
          Math.round((device.bateryStatus / 254) * 100, 2) < 61 &&
            Math.round((device.bateryStatus / 254) * 100, 2) > 40
        "
        class="d-flex align-items-center"
      >
        <img src="@/assets/icons/battery/ico-battery-60.svg" />
        <span class="detail-page__boxes__item__textDashed">
          {{ Math.round((device.bateryStatus / 254) * 100, 2) }} %
        </span>
      </div>
      <div
        v-if="
          Math.round((device.bateryStatus / 254) * 100, 2) < 41 &&
            Math.round((device.bateryStatus / 254) * 100, 2) > 20
        "
        class="d-flex align-items-center"
      >
        <img src="@/assets/icons/battery/ico-battery-40.svg" />
        <span class="detail-page__boxes__item__textDashed">
          {{ Math.round((device.bateryStatus / 254) * 100, 2) }} %
        </span>
      </div>
      <div
        v-else-if="Math.round((device.bateryStatus / 254) * 100, 2) < 21"
        class="d-flex align-items-center"
      >
        <img src="@/assets/icons/battery/ico-battery-20.svg" />
        <span class="">
          {{ Math.round((device.bateryStatus / 254) * 100, 2) }} %
        </span>
      </div>
      <div
        v-else-if="Math.round((device.bateryStatus / 254) * 100, 2) > 80"
        class="d-flex align-items-center"
      >
        <img src="@/assets/icons/battery/ico-battery-full.svg" />
        <span class="detail-page__boxes__item__textDashed">
          {{ Math.round((device.bateryStatus / 254) * 100, 2) }} %
        </span>
      </div>
    </span>
    <span v-if="device.bateryStatus == 0" class="d-flex align-items-center">
      <img src="@/assets/icons/battery/ico-battery-napajeni.svg" />
      AC
    </span>
    <span v-if="device.bateryStatus == 255" class="d-flex align-items-center">
      <img src="@/assets/icons/battery/ico-battery-na.svg" />
      N/A
    </span>
    <span v-if="device.bateryStatus == null" class="d-flex align-items-center">
      <img src="@/assets/icons/battery/ico-battery-na.svg" />
      ?
    </span>
  </div>
</template>

<script>
export default {
  props: {
    device: Object
  },
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
